import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import './i18n';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// No top-level Suspense — it caused hydration mismatch (#418/#423) because
// Puppeteer captures resolved HTML but hydrateRoot sees the fallback.
// Per-route Suspense boundaries in App.js handle lazy-loaded pages instead.
const rootElement = document.getElementById('root');
const app = (
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

if (rootElement.hasChildNodes()) {
  // Move prerendered Emotion CSS from #root to <head> before hydration
  // (injected during Puppeteer prerender so styles ship with HTML)
  rootElement.querySelectorAll('style[data-emotion]').forEach(s => {
    document.head.appendChild(s);
  });

  rootElement.className = '';

  hydrateRoot(rootElement, app, {
    onRecoverableError(error, errorInfo) {
      console.error('[Hydration]', error.message);
      if (errorInfo?.componentStack) {
        console.error('[Hydration] Component stack:', errorInfo.componentStack);
      }
    },
  });
} else {
  createRoot(rootElement).render(app);

  // In Puppeteer: clone Emotion styles into #root for prerender capture
  if (typeof navigator !== 'undefined' && navigator.webdriver) {
    setTimeout(() => {
      document.querySelectorAll('head style[data-emotion]').forEach(s => {
        rootElement.prepend(s.cloneNode(true));
      });
    }, 5000);
  }
}

// Mark hydrated for backwards compat
rootElement.classList.add('hydrated');

reportWebVitals();
